import { isJcsTwgEntitlementsIdToAriEnabled } from '@helpcenter/feature-flags';
import { JiraEntitlementAri } from '@atlassian/ari/jira/entitlement';

export const getEntitlementIdFromAri = (maybeAri: string): string => {
    if (!isJcsTwgEntitlementsIdToAriEnabled()) return maybeAri;

    return JiraEntitlementAri.check(maybeAri) ? JiraEntitlementAri.parse(maybeAri).entitlementId : maybeAri;
};
